import React from "react";

import { eventTint } from "app/utils/calendarColors";
import styles from "./styles.module.scss";

type PropsDef = {
  event: any;
  timeText: string;
};

function getPaymentDotColor(
  paymentStatus: string,
  expiresAt: string,
): string {
  if (paymentStatus === "past_due" || paymentStatus === "failed") {
    return "#e54500";
  }
  if (paymentStatus === "pending" || expiresAt) {
    return "#ffa000";
  }
  return "#43a047";
}

export default function MonthEvent(props: PropsDef) {
  const {
    eventColor,
    payment_method: paymentMethod,
    payment_status: paymentStatus,
    expires_at: expiresAt,
  } = props.event.extendedProps;

  const barColor = eventColor || "#E54500";
  // Shaded only when the booking option has a colour; see eventTint.
  const tint = eventTint(eventColor);

  return (
    <div
      className={styles.month_event}
      style={tint ? { backgroundColor: tint.fill } : undefined}
    >
      <span
        className={styles.month_event_bar}
        style={{ backgroundColor: barColor }}
      />
      <span
        className={styles.month_event_title}
        style={tint ? { color: tint.ink } : undefined}
      >
        {props.event.title}
      </span>
      {paymentMethod && (
        <span
          className={styles.month_event_payment_dot}
          style={{
            backgroundColor: getPaymentDotColor(paymentStatus, expiresAt),
          }}
        />
      )}
    </div>
  );
}
